/* tslint:disable */
/* eslint-disable */
/**
 * Artemis API
 * Artemis Main Application
 *
 * The version of the OpenAPI document: 4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country': AddressCountryEnum;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'streetAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'streetAddress2'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'stateOrProvince': AddressStateOrProvinceEnum;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'zipOrPostalCode': string;
}

export const AddressCountryEnum = {
    UnitedStates: 'UNITED_STATES',
    Canada: 'CANADA'
} as const;

export type AddressCountryEnum = typeof AddressCountryEnum[keyof typeof AddressCountryEnum];
export const AddressStateOrProvinceEnum = {
    Alabama: 'ALABAMA',
    Alaska: 'ALASKA',
    Arizona: 'ARIZONA',
    Arkansas: 'ARKANSAS',
    California: 'CALIFORNIA',
    Colorado: 'COLORADO',
    Connecticut: 'CONNECTICUT',
    Delaware: 'DELAWARE',
    DistrictOfColumbia: 'DISTRICT_OF_COLUMBIA',
    Florida: 'FLORIDA',
    Georgia: 'GEORGIA',
    Hawaii: 'HAWAII',
    Idaho: 'IDAHO',
    Illinois: 'ILLINOIS',
    Indiana: 'INDIANA',
    Iowa: 'IOWA',
    Kansas: 'KANSAS',
    Kentucky: 'KENTUCKY',
    Louisiana: 'LOUISIANA',
    Maine: 'MAINE',
    Maryland: 'MARYLAND',
    Massachusetts: 'MASSACHUSETTS',
    Michigan: 'MICHIGAN',
    Minnesota: 'MINNESOTA',
    Mississippi: 'MISSISSIPPI',
    Missouri: 'MISSOURI',
    Montana: 'MONTANA',
    Nebraska: 'NEBRASKA',
    Nevada: 'NEVADA',
    NewHampshire: 'NEW_HAMPSHIRE',
    NewJersey: 'NEW_JERSEY',
    NewMexico: 'NEW_MEXICO',
    NewYork: 'NEW_YORK',
    NorthCarolina: 'NORTH_CAROLINA',
    NorthDakota: 'NORTH_DAKOTA',
    Ohio: 'OHIO',
    Oklahoma: 'OKLAHOMA',
    Oregon: 'OREGON',
    Pennsylvania: 'PENNSYLVANIA',
    RhodeIsland: 'RHODE_ISLAND',
    SouthCarolina: 'SOUTH_CAROLINA',
    SouthDakota: 'SOUTH_DAKOTA',
    Tennessee: 'TENNESSEE',
    Texas: 'TEXAS',
    Utah: 'UTAH',
    Vermont: 'VERMONT',
    Virginia: 'VIRGINIA',
    Washington: 'WASHINGTON',
    WestVirginia: 'WEST_VIRGINIA',
    Wisconsin: 'WISCONSIN',
    Wyoming: 'WYOMING',
    PuertoRico: 'PUERTO_RICO',
    Alberta: 'ALBERTA',
    BritishColumbia: 'BRITISH_COLUMBIA',
    Manitoba: 'MANITOBA',
    NewBrunswick: 'NEW_BRUNSWICK',
    NewfoundlandAndLabrador: 'NEWFOUNDLAND_AND_LABRADOR',
    NovaScotia: 'NOVA_SCOTIA',
    Ontario: 'ONTARIO',
    PrinceEdwardIsland: 'PRINCE_EDWARD_ISLAND',
    Quebec: 'QUEBEC',
    Saskatchewan: 'SASKATCHEWAN'
} as const;

export type AddressStateOrProvinceEnum = typeof AddressStateOrProvinceEnum[keyof typeof AddressStateOrProvinceEnum];

/**
 * 
 * @export
 * @interface AgentDto
 */
export interface AgentDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    'agentId': string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    'emailAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    'agentCity'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    'agentCountry'?: string;
    /**
     * 
     * @type {Array<ServiceArea>}
     * @memberof AgentDto
     */
    'serviceArea'?: Array<ServiceArea>;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    'avatar'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgentDto
     */
    'specialties'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    'bio'?: string;
    /**
     * 
     * @type {MoneyValue}
     * @memberof AgentDto
     */
    'minPrice'?: MoneyValue;
    /**
     * 
     * @type {MoneyValue}
     * @memberof AgentDto
     */
    'maxPrice'?: MoneyValue;
    /**
     * 
     * @type {MoneyValue}
     * @memberof AgentDto
     */
    'totalSales'?: MoneyValue;
    /**
     * 
     * @type {number}
     * @memberof AgentDto
     */
    'rollingListingCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentDto
     */
    'rollingSoldPropertyCount'?: number;
    /**
     * 
     * @type {MoneyValue}
     * @memberof AgentDto
     */
    'averagePrice'?: MoneyValue;
    /**
     * 
     * @type {number}
     * @memberof AgentDto
     */
    'mostRecentListingDate'?: number;
    /**
     * 
     * @type {Array<Transaction>}
     * @memberof AgentDto
     */
    'recentlyClosedTransactions'?: Array<Transaction>;
}
/**
 * 
 * @export
 * @interface BaseMessage
 */
export interface BaseMessage {
    /**
     * 
     * @type {string}
     * @memberof BaseMessage
     */
    'eventId'?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseMessage
     */
    'createdAt'?: number;
}
/**
 * 
 * @export
 * @interface FailedMessage
 */
export interface FailedMessage {
    /**
     * 
     * @type {string}
     * @memberof FailedMessage
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof FailedMessage
     */
    'createdAt'?: number;
    /**
     * 
     * @type {number}
     * @memberof FailedMessage
     */
    'updatedAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof FailedMessage
     */
    'clientType': FailedMessageClientTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FailedMessage
     */
    'status': FailedMessageStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof FailedMessage
     */
    'reprocessingAttempts'?: number;
    /**
     * 
     * @type {KafkaMessageLocation}
     * @memberof FailedMessage
     */
    'kafkaMessageLocation': KafkaMessageLocation;
    /**
     * 
     * @type {string}
     * @memberof FailedMessage
     */
    'eventId': string;
    /**
     * 
     * @type {string}
     * @memberof FailedMessage
     */
    'key'?: string;
    /**
     * 
     * @type {WrapperBaseMessage}
     * @memberof FailedMessage
     */
    'payload'?: WrapperBaseMessage;
    /**
     * 
     * @type {string}
     * @memberof FailedMessage
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedMessage
     */
    'unprocessed'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FailedMessage
     */
    'processed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FailedMessage
     */
    'shortenedId'?: string;
}

export const FailedMessageClientTypeEnum = {
    Producer: 'PRODUCER',
    Consumer: 'CONSUMER'
} as const;

export type FailedMessageClientTypeEnum = typeof FailedMessageClientTypeEnum[keyof typeof FailedMessageClientTypeEnum];
export const FailedMessageStatusEnum = {
    Blocked: 'BLOCKED',
    Unprocessed: 'UNPROCESSED',
    Processed: 'PROCESSED',
    Failed: 'FAILED',
    ManualOverride: 'MANUAL_OVERRIDE',
    NoActionRequired: 'NO_ACTION_REQUIRED'
} as const;

export type FailedMessageStatusEnum = typeof FailedMessageStatusEnum[keyof typeof FailedMessageStatusEnum];

/**
 * 
 * @export
 * @interface FailedMessageRetryRequest
 */
export interface FailedMessageRetryRequest {
    /**
     * 
     * @type {string}
     * @memberof FailedMessageRetryRequest
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface FailedMessageUpdateStatusRequest
 */
export interface FailedMessageUpdateStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof FailedMessageUpdateStatusRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedMessageUpdateStatusRequest
     */
    'status'?: FailedMessageUpdateStatusRequestStatusEnum;
}

export const FailedMessageUpdateStatusRequestStatusEnum = {
    Blocked: 'BLOCKED',
    Unprocessed: 'UNPROCESSED',
    Processed: 'PROCESSED',
    Failed: 'FAILED',
    ManualOverride: 'MANUAL_OVERRIDE',
    NoActionRequired: 'NO_ACTION_REQUIRED'
} as const;

export type FailedMessageUpdateStatusRequestStatusEnum = typeof FailedMessageUpdateStatusRequestStatusEnum[keyof typeof FailedMessageUpdateStatusRequestStatusEnum];

/**
 * 
 * @export
 * @interface FailedMessagesCriteriaRequest
 */
export interface FailedMessagesCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof FailedMessagesCriteriaRequest
     */
    'topic'?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedMessagesCriteriaRequest
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedMessagesCriteriaRequest
     */
    'createdAtFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedMessagesCriteriaRequest
     */
    'createdAtTo'?: string;
}
/**
 * 
 * @export
 * @interface Filter
 */
export interface Filter {
    /**
     * 
     * @type {string}
     * @memberof Filter
     */
    'listingType'?: FilterListingTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Filter
     */
    'minPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Filter
     */
    'maxPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Filter
     */
    'minBeds'?: number;
    /**
     * 
     * @type {number}
     * @memberof Filter
     */
    'maxBeds'?: number;
    /**
     * 
     * @type {number}
     * @memberof Filter
     */
    'minBaths'?: number;
    /**
     * 
     * @type {number}
     * @memberof Filter
     */
    'maxBaths'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Filter
     */
    'propertyTypes'?: Array<FilterPropertyTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Filter
     */
    'amenities'?: Array<FilterAmenitiesEnum>;
}

export const FilterListingTypeEnum = {
    Buy: 'BUY',
    Rent: 'RENT',
    Unknown: 'UNKNOWN'
} as const;

export type FilterListingTypeEnum = typeof FilterListingTypeEnum[keyof typeof FilterListingTypeEnum];
export const FilterPropertyTypesEnum = {
    VacantLand: 'VACANT_LAND',
    MultiFamily: 'MULTI_FAMILY',
    SingleFamily: 'SINGLE_FAMILY',
    Condo: 'CONDO',
    Retail: 'RETAIL',
    Office: 'OFFICE',
    Hospitality: 'HOSPITALITY',
    Business: 'BUSINESS',
    Agriculture: 'AGRICULTURE',
    Parking: 'PARKING',
    Recreational: 'RECREATIONAL',
    Industrial: 'INDUSTRIAL',
    Other: 'OTHER'
} as const;

export type FilterPropertyTypesEnum = typeof FilterPropertyTypesEnum[keyof typeof FilterPropertyTypesEnum];
export const FilterAmenitiesEnum = {
    Pool: 'POOL',
    HotTub: 'HOT_TUB',
    Garage: 'GARAGE',
    Basement: 'BASEMENT',
    Fireplace: 'FIREPLACE',
    AirConditioning: 'AIR_CONDITIONING',
    Waterfront: 'WATERFRONT',
    WasherDryerHookup: 'WASHER_DRYER_HOOKUP',
    PetsAllowed: 'PETS_ALLOWED',
    Backyard: 'BACKYARD',
    Golf: 'GOLF',
    Porch: 'PORCH',
    PatioDeck: 'PATIO_DECK',
    TennisCourt: 'TENNIS_COURT',
    Other: 'OTHER'
} as const;

export type FilterAmenitiesEnum = typeof FilterAmenitiesEnum[keyof typeof FilterAmenitiesEnum];

/**
 * 
 * @export
 * @interface GenericSearchResponseAgentDto
 */
export interface GenericSearchResponseAgentDto {
    /**
     * 
     * @type {number}
     * @memberof GenericSearchResponseAgentDto
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericSearchResponseAgentDto
     */
    'pageSize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GenericSearchResponseAgentDto
     */
    'hasNext'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GenericSearchResponseAgentDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericSearchResponseAgentDto
     */
    'totalPages'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GenericSearchResponseAgentDto
     */
    'sortBy'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GenericSearchResponseAgentDto
     */
    'sortDirection'?: GenericSearchResponseAgentDtoSortDirectionEnum;
    /**
     * 
     * @type {Array<AgentDto>}
     * @memberof GenericSearchResponseAgentDto
     */
    'results'?: Array<AgentDto>;
}

export const GenericSearchResponseAgentDtoSortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type GenericSearchResponseAgentDtoSortDirectionEnum = typeof GenericSearchResponseAgentDtoSortDirectionEnum[keyof typeof GenericSearchResponseAgentDtoSortDirectionEnum];

/**
 * 
 * @export
 * @interface GenericSearchResponseFailedMessage
 */
export interface GenericSearchResponseFailedMessage {
    /**
     * 
     * @type {number}
     * @memberof GenericSearchResponseFailedMessage
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericSearchResponseFailedMessage
     */
    'pageSize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GenericSearchResponseFailedMessage
     */
    'hasNext'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GenericSearchResponseFailedMessage
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericSearchResponseFailedMessage
     */
    'totalPages'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GenericSearchResponseFailedMessage
     */
    'sortBy'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GenericSearchResponseFailedMessage
     */
    'sortDirection'?: GenericSearchResponseFailedMessageSortDirectionEnum;
    /**
     * 
     * @type {Array<FailedMessage>}
     * @memberof GenericSearchResponseFailedMessage
     */
    'results'?: Array<FailedMessage>;
}

export const GenericSearchResponseFailedMessageSortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type GenericSearchResponseFailedMessageSortDirectionEnum = typeof GenericSearchResponseFailedMessageSortDirectionEnum[keyof typeof GenericSearchResponseFailedMessageSortDirectionEnum];

/**
 * 
 * @export
 * @interface GenericSearchResponseReferralDto
 */
export interface GenericSearchResponseReferralDto {
    /**
     * 
     * @type {number}
     * @memberof GenericSearchResponseReferralDto
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericSearchResponseReferralDto
     */
    'pageSize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GenericSearchResponseReferralDto
     */
    'hasNext'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GenericSearchResponseReferralDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericSearchResponseReferralDto
     */
    'totalPages'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GenericSearchResponseReferralDto
     */
    'sortBy'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GenericSearchResponseReferralDto
     */
    'sortDirection'?: GenericSearchResponseReferralDtoSortDirectionEnum;
    /**
     * 
     * @type {Array<ReferralDto>}
     * @memberof GenericSearchResponseReferralDto
     */
    'results'?: Array<ReferralDto>;
}

export const GenericSearchResponseReferralDtoSortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type GenericSearchResponseReferralDtoSortDirectionEnum = typeof GenericSearchResponseReferralDtoSortDirectionEnum[keyof typeof GenericSearchResponseReferralDtoSortDirectionEnum];

/**
 * 
 * @export
 * @interface GeoPoint
 */
export interface GeoPoint {
    /**
     * 
     * @type {number}
     * @memberof GeoPoint
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoPoint
     */
    'lon'?: number;
}
/**
 * 
 * @export
 * @interface IngestionStatus
 */
export interface IngestionStatus {
    /**
     * 
     * @type {number}
     * @memberof IngestionStatus
     */
    'recordCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IngestionStatus
     */
    'status'?: boolean;
}
/**
 * 
 * @export
 * @interface KafkaMessageLocation
 */
export interface KafkaMessageLocation {
    /**
     * 
     * @type {string}
     * @memberof KafkaMessageLocation
     */
    'topic': string;
    /**
     * 
     * @type {number}
     * @memberof KafkaMessageLocation
     */
    'partition'?: number;
    /**
     * 
     * @type {number}
     * @memberof KafkaMessageLocation
     */
    'offset'?: number;
}
/**
 * 
 * @export
 * @interface LatLong
 */
export interface LatLong {
    /**
     * 
     * @type {number}
     * @memberof LatLong
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof LatLong
     */
    'lon'?: number;
}
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'stateOrProvince'?: LocationStateOrProvinceEnum;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'zipCode'?: string;
    /**
     * 
     * @type {GeoPoint}
     * @memberof Location
     */
    'coordinates': GeoPoint;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'radius': number;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'unitOfMeasure': LocationUnitOfMeasureEnum;
}

export const LocationStateOrProvinceEnum = {
    Alabama: 'ALABAMA',
    Alaska: 'ALASKA',
    Arizona: 'ARIZONA',
    Arkansas: 'ARKANSAS',
    California: 'CALIFORNIA',
    Colorado: 'COLORADO',
    Connecticut: 'CONNECTICUT',
    Delaware: 'DELAWARE',
    DistrictOfColumbia: 'DISTRICT_OF_COLUMBIA',
    Florida: 'FLORIDA',
    Georgia: 'GEORGIA',
    Hawaii: 'HAWAII',
    Idaho: 'IDAHO',
    Illinois: 'ILLINOIS',
    Indiana: 'INDIANA',
    Iowa: 'IOWA',
    Kansas: 'KANSAS',
    Kentucky: 'KENTUCKY',
    Louisiana: 'LOUISIANA',
    Maine: 'MAINE',
    Maryland: 'MARYLAND',
    Massachusetts: 'MASSACHUSETTS',
    Michigan: 'MICHIGAN',
    Minnesota: 'MINNESOTA',
    Mississippi: 'MISSISSIPPI',
    Missouri: 'MISSOURI',
    Montana: 'MONTANA',
    Nebraska: 'NEBRASKA',
    Nevada: 'NEVADA',
    NewHampshire: 'NEW_HAMPSHIRE',
    NewJersey: 'NEW_JERSEY',
    NewMexico: 'NEW_MEXICO',
    NewYork: 'NEW_YORK',
    NorthCarolina: 'NORTH_CAROLINA',
    NorthDakota: 'NORTH_DAKOTA',
    Ohio: 'OHIO',
    Oklahoma: 'OKLAHOMA',
    Oregon: 'OREGON',
    Pennsylvania: 'PENNSYLVANIA',
    RhodeIsland: 'RHODE_ISLAND',
    SouthCarolina: 'SOUTH_CAROLINA',
    SouthDakota: 'SOUTH_DAKOTA',
    Tennessee: 'TENNESSEE',
    Texas: 'TEXAS',
    Utah: 'UTAH',
    Vermont: 'VERMONT',
    Virginia: 'VIRGINIA',
    Washington: 'WASHINGTON',
    WestVirginia: 'WEST_VIRGINIA',
    Wisconsin: 'WISCONSIN',
    Wyoming: 'WYOMING',
    PuertoRico: 'PUERTO_RICO',
    Alberta: 'ALBERTA',
    BritishColumbia: 'BRITISH_COLUMBIA',
    Manitoba: 'MANITOBA',
    NewBrunswick: 'NEW_BRUNSWICK',
    NewfoundlandAndLabrador: 'NEWFOUNDLAND_AND_LABRADOR',
    NovaScotia: 'NOVA_SCOTIA',
    Ontario: 'ONTARIO',
    PrinceEdwardIsland: 'PRINCE_EDWARD_ISLAND',
    Quebec: 'QUEBEC',
    Saskatchewan: 'SASKATCHEWAN'
} as const;

export type LocationStateOrProvinceEnum = typeof LocationStateOrProvinceEnum[keyof typeof LocationStateOrProvinceEnum];
export const LocationUnitOfMeasureEnum = {
    Kilometers: 'KILOMETERS',
    Miles: 'MILES'
} as const;

export type LocationUnitOfMeasureEnum = typeof LocationUnitOfMeasureEnum[keyof typeof LocationUnitOfMeasureEnum];

/**
 * 
 * @export
 * @interface MoneyValue
 */
export interface MoneyValue {
    /**
     * 
     * @type {number}
     * @memberof MoneyValue
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MoneyValue
     */
    'currency'?: MoneyValueCurrencyEnum;
}

export const MoneyValueCurrencyEnum = {
    Usd: 'USD',
    Cad: 'CAD'
} as const;

export type MoneyValueCurrencyEnum = typeof MoneyValueCurrencyEnum[keyof typeof MoneyValueCurrencyEnum];

/**
 * 
 * @export
 * @interface RealAddress
 */
export interface RealAddress {
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'streetAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'addressLine1'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'addressLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'streetNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'streetDirectionPrefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'streetName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'streetSuffix'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'streetDirectionSuffix'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'unitNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'boxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'province'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'additionalStreetInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'communityName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'neighbourhood'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAddress
     */
    'subdivision'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealAddress
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealAddress
     */
    'longitude'?: number;
}
/**
 * 
 * @export
 * @interface RealAgentDetails
 */
export interface RealAgentDetails {
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'mlsId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'sourceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'middleName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'namePrefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'nameSuffix'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'nickname'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealAgentDetails
     */
    'lastUpdated'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'position'?: string;
    /**
     * 
     * @type {Array<RealWebsite>}
     * @memberof RealAgentDetails
     */
    'websites'?: Array<RealWebsite>;
    /**
     * 
     * @type {Array<RealPhone>}
     * @memberof RealAgentDetails
     */
    'phones'?: Array<RealPhone>;
    /**
     * 
     * @type {RealOfficeDetails}
     * @memberof RealAgentDetails
     */
    'office'?: RealOfficeDetails;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealAgentDetails
     */
    'educationCredentials'?: Array<string>;
    /**
     * 
     * @type {Array<RealPhoto>}
     * @memberof RealAgentDetails
     */
    'photos'?: Array<RealPhoto>;
    /**
     * 
     * @type {RealAddress}
     * @memberof RealAgentDetails
     */
    'address'?: RealAddress;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealAgentDetails
     */
    'specialties'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealAgentDetails
     */
    'designations'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealAgentDetails
     */
    'languages'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealAgentDetails
     */
    'tradingAreas'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'officeNationalAssociationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'nationalAssociationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'aor'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'aorKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'fax'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'pager'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealAgentDetails
     */
    'originalEntryTimestamp'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RealAgentDetails
     */
    'hasEmail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RealAgentDetails
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface RealAlternateURL
 */
export interface RealAlternateURL {
    /**
     * 
     * @type {string}
     * @memberof RealAlternateURL
     */
    'brochureLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAlternateURL
     */
    'mapLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAlternateURL
     */
    'photoLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAlternateURL
     */
    'soundLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAlternateURL
     */
    'videoLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealAlternateURL
     */
    'otherLink'?: string;
}
/**
 * 
 * @export
 * @interface RealBathrooms
 */
export interface RealBathrooms {
    /**
     * 
     * @type {number}
     * @memberof RealBathrooms
     */
    'bathroomsTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealBathrooms
     */
    'bathroomsPartial'?: number;
}
/**
 * 
 * @export
 * @interface RealBedrooms
 */
export interface RealBedrooms {
    /**
     * 
     * @type {number}
     * @memberof RealBedrooms
     */
    'bedroomsAboveGround'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealBedrooms
     */
    'bedroomsBelowGround'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealBedrooms
     */
    'bedroomsTotal'?: number;
}
/**
 * 
 * @export
 * @interface RealBuilding
 */
export interface RealBuilding {
    /**
     * 
     * @type {number}
     * @memberof RealBuilding
     */
    'aboveGradeFinishedArea'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'aboveGradeFinishedAreaUnits'?: string;
    /**
     * 
     * @type {RealBathrooms}
     * @memberof RealBuilding
     */
    'bathrooms'?: RealBathrooms;
    /**
     * 
     * @type {RealBedrooms}
     * @memberof RealBuilding
     */
    'bedrooms'?: RealBedrooms;
    /**
     * 
     * @type {number}
     * @memberof RealBuilding
     */
    'age'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'amenities'?: Array<RealBuildingAmenitiesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'amperage'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'anchor'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'anchorsCoTenants'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'appliances'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'architecturalStyle'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'associationFeeIncludes'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'availabilityDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'basementDevelopment'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'basementFeatures'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'basementType'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'bomaRating'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealBuilding
     */
    'ceilingHeight'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'ceilingType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'clearCeilingHeight'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'commonInterest'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'communityFeatures'?: Array<string>;
    /**
     * 
     * @type {RealConstructionDetails}
     * @memberof RealBuilding
     */
    'constructionDetails'?: RealConstructionDetails;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'coolingType'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'directions'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'electric'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'energuideRating'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'exteriorFinish'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'fireProtection'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'fireplaceFuel'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof RealBuilding
     */
    'fireplacePresent'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RealBuilding
     */
    'fireplaceTotal'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'fireplaceType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'fixture'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'flooringType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'foundationType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'heatingFuel'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'heatingType'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'inclusions'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RealBuilding
     */
    'internetAddressDisplay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RealBuilding
     */
    'internetEntireListingDisplay'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RealBuilding
     */
    'livingArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealBuilding
     */
    'numberOfUnitsTotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'originatingSystemName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'parcelNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'photosChangeTimestamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealBuilding
     */
    'photosCount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'possibleUse'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'propertyCondition'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'leedsCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'leedsRating'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealBuilding
     */
    'renovatedDate'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'roofMaterial'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'roofStyle'?: Array<string>;
    /**
     * 
     * @type {Array<RealRoom>}
     * @memberof RealBuilding
     */
    'rooms'?: Array<RealRoom>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'securityFeatures'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RealBuilding
     */
    'storiesTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealBuilding
     */
    'sizeExterior'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealBuilding
     */
    'sizeInterior'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'standardStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'statusChangeTimestamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealBuilding
     */
    'totalActualRent'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealBuilding
     */
    'totalBuildings'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealBuilding
     */
    'sizeInteriorFinished'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'storeFront'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'totalFinishedArea'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'type'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'uffi'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'unitType'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'utilityPower'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'utilityWater'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealBuilding
     */
    'vacancyRate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealBuilding
     */
    'waterSource'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof RealBuilding
     */
    'propertyAttached'?: boolean;
}

export const RealBuildingAmenitiesEnum = {
    Pool: 'POOL',
    HotTub: 'HOT_TUB',
    Garage: 'GARAGE',
    Basement: 'BASEMENT',
    Fireplace: 'FIREPLACE',
    AirConditioning: 'AIR_CONDITIONING',
    Waterfront: 'WATERFRONT',
    WasherDryerHookup: 'WASHER_DRYER_HOOKUP',
    PetsAllowed: 'PETS_ALLOWED',
    Backyard: 'BACKYARD',
    Golf: 'GOLF',
    Porch: 'PORCH',
    PatioDeck: 'PATIO_DECK',
    TennisCourt: 'TENNIS_COURT',
    Other: 'OTHER'
} as const;

export type RealBuildingAmenitiesEnum = typeof RealBuildingAmenitiesEnum[keyof typeof RealBuildingAmenitiesEnum];

/**
 * 
 * @export
 * @interface RealBusiness
 */
export interface RealBusiness {
    /**
     * 
     * @type {string}
     * @memberof RealBusiness
     */
    'businessType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealBusiness
     */
    'businessSubType'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealBusiness
     */
    'establishedDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealBusiness
     */
    'franchise'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealBusiness
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealBusiness
     */
    'operatingSince'?: number;
}
/**
 * 
 * @export
 * @interface RealCharacteristics
 */
export interface RealCharacteristics {
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'features'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealCharacteristics
     */
    'propertyType'?: RealCharacteristicsPropertyTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'structureType'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealCharacteristics
     */
    'zoningType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealCharacteristics
     */
    'zoningDescription'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'communicationType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'rentalEquipmentType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'easement'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'poolType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'poolFeatures'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'rightType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'roadType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'liveStockType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'machinery'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'storageType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'equipmentType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'farmType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'irrigationType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'structure'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'signType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'loadingType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'crop'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'viewType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'waterFrontType'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealCharacteristics
     */
    'waterFrontName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'communityFeatures'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealCharacteristics
     */
    'otherEquipment'?: Array<string>;
}

export const RealCharacteristicsPropertyTypeEnum = {
    VacantLand: 'VACANT_LAND',
    MultiFamily: 'MULTI_FAMILY',
    SingleFamily: 'SINGLE_FAMILY',
    Condo: 'CONDO',
    Retail: 'RETAIL',
    Office: 'OFFICE',
    Hospitality: 'HOSPITALITY',
    Business: 'BUSINESS',
    Agriculture: 'AGRICULTURE',
    Parking: 'PARKING',
    Recreational: 'RECREATIONAL',
    Industrial: 'INDUSTRIAL',
    Other: 'OTHER'
} as const;

export type RealCharacteristicsPropertyTypeEnum = typeof RealCharacteristicsPropertyTypeEnum[keyof typeof RealCharacteristicsPropertyTypeEnum];

/**
 * 
 * @export
 * @interface RealConstructionDetails
 */
export interface RealConstructionDetails {
    /**
     * 
     * @type {number}
     * @memberof RealConstructionDetails
     */
    'yearBuilt'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealConstructionDetails
     */
    'constructionMaterial'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealConstructionDetails
     */
    'constructionStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealConstructionDetails
     */
    'constructionStyleAttachment'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealConstructionDetails
     */
    'constructionStyleOther'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealConstructionDetails
     */
    'constructionStyleSplitLevel'?: string;
}
/**
 * 
 * @export
 * @interface RealEvent
 */
export interface RealEvent {
    /**
     * 
     * @type {number}
     * @memberof RealEvent
     */
    'startDateTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealEvent
     */
    'endDateTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealEvent
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealEvent
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface RealImage
 */
export interface RealImage {
    /**
     * 
     * @type {string}
     * @memberof RealImage
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealImage
     */
    'width'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealImage
     */
    'format'?: string;
}
/**
 * 
 * @export
 * @interface RealLand
 */
export interface RealLand {
    /**
     * 
     * @type {number}
     * @memberof RealLand
     */
    'lotSizeArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealLand
     */
    'sizeTotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealLand
     */
    'sizeTotalText'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealLand
     */
    'sizeFrontage'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealLand
     */
    'accessType'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof RealLand
     */
    'acreage'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealLand
     */
    'amenities'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RealLand
     */
    'clearedTotal'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealLand
     */
    'currentUse'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof RealLand
     */
    'divisible'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RealLand
     */
    'fenceTotal'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealLand
     */
    'fenceType'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealLand
     */
    'frontsOn'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealLand
     */
    'landDisposition'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealLand
     */
    'landscapeFeatures'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RealLand
     */
    'pastureTotal'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealLand
     */
    'sewer'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealLand
     */
    'sizeDepth'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealLand
     */
    'sizeIrregular'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealLand
     */
    'soilEvaluation'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealLand
     */
    'soilType'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealLand
     */
    'surfaceWater'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RealLand
     */
    'tiledTotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealLand
     */
    'topographyType'?: string;
}
/**
 * 
 * @export
 * @interface RealListingInformation
 */
export interface RealListingInformation {
    /**
     * 
     * @type {number}
     * @memberof RealListingInformation
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealListingInformation
     */
    'pricePerTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealListingInformation
     */
    'pricePerUnit'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealListingInformation
     */
    'listingContractDate'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealListingInformation
     */
    'documentsAvailable'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'publicRemarks'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'locationDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'plan'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealListingInformation
     */
    'maintenanceFee'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'maintenanceFeePaymentUnit'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealListingInformation
     */
    'maintenanceFeeType'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'managementCompany'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealListingInformation
     */
    'lease'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'leasePerTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'leasePerUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'leaseTermRemaining'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'easeTermRemainingFreq'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealListingInformation
     */
    'leaseType'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'transactionType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'ownershipType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'countyID'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'stateOrProvince'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'additionalInformationIndicator'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealListingInformation
     */
    'moreInformationLink'?: string;
}
/**
 * 
 * @export
 * @interface RealLogo
 */
export interface RealLogo {
    /**
     * 
     * @type {string}
     * @memberof RealLogo
     */
    'thumbnailURL'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealLogo
     */
    'logoLastUpdated'?: number;
}
/**
 * 
 * @export
 * @interface RealOfficeDetails
 */
export interface RealOfficeDetails {
    /**
     * 
     * @type {string}
     * @memberof RealOfficeDetails
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealOfficeDetails
     */
    'sourceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealOfficeDetails
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealOfficeDetails
     */
    'lastUpdated'?: number;
    /**
     * 
     * @type {RealLogo}
     * @memberof RealOfficeDetails
     */
    'logo'?: RealLogo;
    /**
     * 
     * @type {string}
     * @memberof RealOfficeDetails
     */
    'organizationType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealOfficeDetails
     */
    'designation'?: string;
    /**
     * 
     * @type {RealAddress}
     * @memberof RealOfficeDetails
     */
    'realAddress'?: RealAddress;
    /**
     * 
     * @type {Array<RealPhone>}
     * @memberof RealOfficeDetails
     */
    'phones'?: Array<RealPhone>;
    /**
     * 
     * @type {Array<RealWebsite>}
     * @memberof RealOfficeDetails
     */
    'websites'?: Array<RealWebsite>;
    /**
     * 
     * @type {string}
     * @memberof RealOfficeDetails
     */
    'franchiser'?: string;
}
/**
 * 
 * @export
 * @interface RealParking
 */
export interface RealParking {
    /**
     * 
     * @type {string}
     * @memberof RealParking
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealParking
     */
    'spaces'?: string;
}
/**
 * 
 * @export
 * @interface RealParkingDetails
 */
export interface RealParkingDetails {
    /**
     * 
     * @type {number}
     * @memberof RealParkingDetails
     */
    'parkingSpaceTotal'?: number;
    /**
     * 
     * @type {Array<RealParking>}
     * @memberof RealParkingDetails
     */
    'parkingSpaces'?: Array<RealParking>;
}
/**
 * 
 * @export
 * @interface RealPhone
 */
export interface RealPhone {
    /**
     * 
     * @type {string}
     * @memberof RealPhone
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealPhone
     */
    'contactType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealPhone
     */
    'phoneType'?: string;
}
/**
 * 
 * @export
 * @interface RealPhoto
 */
export interface RealPhoto {
    /**
     * 
     * @type {number}
     * @memberof RealPhoto
     */
    'sequenceID'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealPhoto
     */
    'caption'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealPhoto
     */
    'lastUpdated'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealPhoto
     */
    'subjectType'?: string;
    /**
     * 
     * @type {RealResponsiveImages}
     * @memberof RealPhoto
     */
    'realResponsiveImages'?: RealResponsiveImages;
    /**
     * 
     * @type {boolean}
     * @memberof RealPhoto
     */
    'preferred'?: boolean;
}
/**
 * 
 * @export
 * @interface RealPropertiesResponse
 */
export interface RealPropertiesResponse {
    /**
     * 
     * @type {number}
     * @memberof RealPropertiesResponse
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealPropertiesResponse
     */
    'pageSize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RealPropertiesResponse
     */
    'hasNextPage'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RealPropertiesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<RealPropertyDetails>}
     * @memberof RealPropertiesResponse
     */
    'realPropertyDetailsList'?: Array<RealPropertyDetails>;
}
/**
 * 
 * @export
 * @interface RealPropertyDetails
 */
export interface RealPropertyDetails {
    /**
     * 
     * @type {string}
     * @memberof RealPropertyDetails
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealPropertyDetails
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealPropertyDetails
     */
    'sourceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealPropertyDetails
     */
    'listingId'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealPropertyDetails
     */
    'lastUpdated'?: number;
    /**
     * 
     * @type {Array<RealAgentDetails>}
     * @memberof RealPropertyDetails
     */
    'agentList'?: Array<RealAgentDetails>;
    /**
     * 
     * @type {RealAddress}
     * @memberof RealPropertyDetails
     */
    'address'?: RealAddress;
    /**
     * 
     * @type {string}
     * @memberof RealPropertyDetails
     */
    'board'?: string;
    /**
     * 
     * @type {RealBusiness}
     * @memberof RealPropertyDetails
     */
    'business'?: RealBusiness;
    /**
     * 
     * @type {RealBuilding}
     * @memberof RealPropertyDetails
     */
    'building'?: RealBuilding;
    /**
     * 
     * @type {RealLand}
     * @memberof RealPropertyDetails
     */
    'land'?: RealLand;
    /**
     * 
     * @type {RealAlternateURL}
     * @memberof RealPropertyDetails
     */
    'alternateURL'?: RealAlternateURL;
    /**
     * 
     * @type {Array<RealEvent>}
     * @memberof RealPropertyDetails
     */
    'openHouse'?: Array<RealEvent>;
    /**
     * 
     * @type {Array<RealEvent>}
     * @memberof RealPropertyDetails
     */
    'liveStream'?: Array<RealEvent>;
    /**
     * 
     * @type {RealParkingDetails}
     * @memberof RealPropertyDetails
     */
    'parkingDetails'?: RealParkingDetails;
    /**
     * 
     * @type {Array<RealPhoto>}
     * @memberof RealPropertyDetails
     */
    'propertyPhotos'?: Array<RealPhoto>;
    /**
     * 
     * @type {Array<RealUtility>}
     * @memberof RealPropertyDetails
     */
    'utilitiesAvailable'?: Array<RealUtility>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealPropertyDetails
     */
    'amenitiesNearBy'?: Array<string>;
    /**
     * 
     * @type {RealListingInformation}
     * @memberof RealPropertyDetails
     */
    'listingInformation'?: RealListingInformation;
    /**
     * 
     * @type {Array<RealOfficeDetails>}
     * @memberof RealPropertyDetails
     */
    'realOfficeDetails'?: Array<RealOfficeDetails>;
    /**
     * 
     * @type {Array<RealWebsite>}
     * @memberof RealPropertyDetails
     */
    'websites'?: Array<RealWebsite>;
    /**
     * 
     * @type {GeoPoint}
     * @memberof RealPropertyDetails
     */
    'location'?: GeoPoint;
    /**
     * 
     * @type {string}
     * @memberof RealPropertyDetails
     */
    'listingType'?: RealPropertyDetailsListingTypeEnum;
    /**
     * 
     * @type {RealCharacteristics}
     * @memberof RealPropertyDetails
     */
    'realCharacteristics'?: RealCharacteristics;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealPropertyDetails
     */
    'communityFeatures'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RealPropertyDetails
     */
    'livingArea'?: string;
    /**
     * 
     * @type {RealTaxHistory}
     * @memberof RealPropertyDetails
     */
    'taxHistory'?: RealTaxHistory;
}

export const RealPropertyDetailsListingTypeEnum = {
    Buy: 'BUY',
    Rent: 'RENT',
    Unknown: 'UNKNOWN'
} as const;

export type RealPropertyDetailsListingTypeEnum = typeof RealPropertyDetailsListingTypeEnum[keyof typeof RealPropertyDetailsListingTypeEnum];

/**
 * 
 * @export
 * @interface RealResponsiveImages
 */
export interface RealResponsiveImages {
    /**
     * 
     * @type {Array<RealImage>}
     * @memberof RealResponsiveImages
     */
    'realImages'?: Array<RealImage>;
}
/**
 * 
 * @export
 * @interface RealRoom
 */
export interface RealRoom {
    /**
     * 
     * @type {string}
     * @memberof RealRoom
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealRoom
     */
    'width'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealRoom
     */
    'level'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealRoom
     */
    'length'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealRoom
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealRoom
     */
    'dimension'?: string;
}
/**
 * 
 * @export
 * @interface RealTaxHistory
 */
export interface RealTaxHistory {
    /**
     * 
     * @type {number}
     * @memberof RealTaxHistory
     */
    'taxAnnualAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealTaxHistory
     */
    'taxBlock'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealTaxHistory
     */
    'taxLot'?: string;
    /**
     * 
     * @type {number}
     * @memberof RealTaxHistory
     */
    'taxYear'?: number;
}
/**
 * 
 * @export
 * @interface RealUtility
 */
export interface RealUtility {
    /**
     * 
     * @type {string}
     * @memberof RealUtility
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealUtility
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface RealWebsite
 */
export interface RealWebsite {
    /**
     * 
     * @type {string}
     * @memberof RealWebsite
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealWebsite
     */
    'contactType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealWebsite
     */
    'websiteType'?: string;
}
/**
 * 
 * @export
 * @interface ReferralDto
 */
export interface ReferralDto {
    /**
     * 
     * @type {string}
     * @memberof ReferralDto
     */
    'referralId'?: string;
    /**
     * 
     * @type {Array<Location>}
     * @memberof ReferralDto
     */
    'locationPreference'?: Array<Location>;
    /**
     * 
     * @type {string}
     * @memberof ReferralDto
     */
    'clientRole'?: ReferralDtoClientRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof ReferralDto
     */
    'referralCommission'?: number;
    /**
     * 
     * @type {MoneyValue}
     * @memberof ReferralDto
     */
    'minPrice'?: MoneyValue;
    /**
     * 
     * @type {MoneyValue}
     * @memberof ReferralDto
     */
    'maxPrice'?: MoneyValue;
    /**
     * 
     * @type {string}
     * @memberof ReferralDto
     */
    'timeline'?: ReferralDtoTimelineEnum;
    /**
     * 
     * @type {number}
     * @memberof ReferralDto
     */
    'createdAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReferralDto
     */
    'agentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralDto
     */
    'referralAgentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralDto
     */
    'referralAgentCity'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralDto
     */
    'referralAgentCountry'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralDto
     */
    'avatar'?: string;
}

export const ReferralDtoClientRoleEnum = {
    Buyer: 'BUYER',
    Seller: 'SELLER',
    Tenant: 'TENANT',
    Landlord: 'LANDLORD'
} as const;

export type ReferralDtoClientRoleEnum = typeof ReferralDtoClientRoleEnum[keyof typeof ReferralDtoClientRoleEnum];
export const ReferralDtoTimelineEnum = {
    From0To3Months: 'FROM_0_TO_3_MONTHS',
    From3To6Months: 'FROM_3_TO_6_MONTHS',
    From6To12Months: 'FROM_6_TO_12_MONTHS',
    Unknown: 'UNKNOWN'
} as const;

export type ReferralDtoTimelineEnum = typeof ReferralDtoTimelineEnum[keyof typeof ReferralDtoTimelineEnum];

/**
 * 
 * @export
 * @interface SearchPropertiesLocationRequest
 */
export interface SearchPropertiesLocationRequest {
    /**
     * 
     * @type {LatLong}
     * @memberof SearchPropertiesLocationRequest
     */
    'latLong'?: LatLong;
    /**
     * 
     * @type {string}
     * @memberof SearchPropertiesLocationRequest
     */
    'searchDistanceUnit'?: SearchPropertiesLocationRequestSearchDistanceUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof SearchPropertiesLocationRequest
     */
    'distance'?: number;
    /**
     * 
     * @type {Filter}
     * @memberof SearchPropertiesLocationRequest
     */
    'filter'?: Filter;
    /**
     * 
     * @type {number}
     * @memberof SearchPropertiesLocationRequest
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchPropertiesLocationRequest
     */
    'pageSize'?: number;
}

export const SearchPropertiesLocationRequestSearchDistanceUnitEnum = {
    Kilometers: 'KILOMETERS',
    Miles: 'MILES'
} as const;

export type SearchPropertiesLocationRequestSearchDistanceUnitEnum = typeof SearchPropertiesLocationRequestSearchDistanceUnitEnum[keyof typeof SearchPropertiesLocationRequestSearchDistanceUnitEnum];

/**
 * 
 * @export
 * @interface SearchPropertiesPolygonRequest
 */
export interface SearchPropertiesPolygonRequest {
    /**
     * 
     * @type {Array<LatLong>}
     * @memberof SearchPropertiesPolygonRequest
     */
    'points'?: Array<LatLong>;
    /**
     * 
     * @type {number}
     * @memberof SearchPropertiesPolygonRequest
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchPropertiesPolygonRequest
     */
    'pageSize'?: number;
    /**
     * 
     * @type {Filter}
     * @memberof SearchPropertiesPolygonRequest
     */
    'filter'?: Filter;
}
/**
 * 
 * @export
 * @interface ServiceArea
 */
export interface ServiceArea {
    /**
     * 
     * @type {string}
     * @memberof ServiceArea
     */
    'agentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceArea
     */
    'address'?: string;
    /**
     * 
     * @type {GeoPoint}
     * @memberof ServiceArea
     */
    'location'?: GeoPoint;
    /**
     * 
     * @type {number}
     * @memberof ServiceArea
     */
    'radius'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceArea
     */
    'radiusUnit'?: ServiceAreaRadiusUnitEnum;
}

export const ServiceAreaRadiusUnitEnum = {
    Kilometers: 'KILOMETERS',
    Miles: 'MILES'
} as const;

export type ServiceAreaRadiusUnitEnum = typeof ServiceAreaRadiusUnitEnum[keyof typeof ServiceAreaRadiusUnitEnum];

/**
 * 
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * 
     * @type {Address}
     * @memberof Transaction
     */
    'address'?: Address;
    /**
     * 
     * @type {MoneyValue}
     * @memberof Transaction
     */
    'price'?: MoneyValue;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'closedAt'?: number;
}
/**
 * 
 * @export
 * @interface UpdateFailedMessageStatusBatch
 */
export interface UpdateFailedMessageStatusBatch {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateFailedMessageStatusBatch
     */
    'ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateFailedMessageStatusBatch
     */
    'status': UpdateFailedMessageStatusBatchStatusEnum;
}

export const UpdateFailedMessageStatusBatchStatusEnum = {
    Blocked: 'BLOCKED',
    Unprocessed: 'UNPROCESSED',
    Processed: 'PROCESSED',
    Failed: 'FAILED',
    ManualOverride: 'MANUAL_OVERRIDE',
    NoActionRequired: 'NO_ACTION_REQUIRED'
} as const;

export type UpdateFailedMessageStatusBatchStatusEnum = typeof UpdateFailedMessageStatusBatchStatusEnum[keyof typeof UpdateFailedMessageStatusBatchStatusEnum];

/**
 * 
 * @export
 * @interface WrapperBaseMessage
 */
export interface WrapperBaseMessage {
    /**
     * 
     * @type {BaseMessage}
     * @memberof WrapperBaseMessage
     */
    'message'?: BaseMessage;
    /**
     * 
     * @type {string}
     * @memberof WrapperBaseMessage
     */
    '_class'?: string;
}

/**
 * AgentControllerApi - axios parameter creator
 * @export
 */
export const AgentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Agents
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [agentName] 
         * @param {GetAgentsSearchDistanceUnitEnum} [searchDistanceUnit] 
         * @param {number} [distance] 
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgents: async (pageNumber?: number, pageSize?: number, agentName?: string, searchDistanceUnit?: GetAgentsSearchDistanceUnitEnum, distance?: number, latitude?: number, longitude?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/agents/referral-central-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (agentName !== undefined) {
                localVarQueryParameter['agentName'] = agentName;
            }

            if (searchDistanceUnit !== undefined) {
                localVarQueryParameter['searchDistanceUnit'] = searchDistanceUnit;
            }

            if (distance !== undefined) {
                localVarQueryParameter['distance'] = distance;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reindex Agent by id on Active index
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAgentById: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('indexAgentById', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/reindex/{agentId}`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Index Agents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAgents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/agents/reindex`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentControllerApi - functional programming interface
 * @export
 */
export const AgentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Agents
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [agentName] 
         * @param {GetAgentsSearchDistanceUnitEnum} [searchDistanceUnit] 
         * @param {number} [distance] 
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgents(pageNumber?: number, pageSize?: number, agentName?: string, searchDistanceUnit?: GetAgentsSearchDistanceUnitEnum, distance?: number, latitude?: number, longitude?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericSearchResponseAgentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgents(pageNumber, pageSize, agentName, searchDistanceUnit, distance, latitude, longitude, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentControllerApi.getAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reindex Agent by id on Active index
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexAgentById(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexAgentById(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentControllerApi.indexAgentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Index Agents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexAgents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexAgents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentControllerApi.indexAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentControllerApi - factory interface
 * @export
 */
export const AgentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Agents
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [agentName] 
         * @param {GetAgentsSearchDistanceUnitEnum} [searchDistanceUnit] 
         * @param {number} [distance] 
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgents(pageNumber?: number, pageSize?: number, agentName?: string, searchDistanceUnit?: GetAgentsSearchDistanceUnitEnum, distance?: number, latitude?: number, longitude?: number, options?: RawAxiosRequestConfig): AxiosPromise<GenericSearchResponseAgentDto> {
            return localVarFp.getAgents(pageNumber, pageSize, agentName, searchDistanceUnit, distance, latitude, longitude, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reindex Agent by id on Active index
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAgentById(agentId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.indexAgentById(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Index Agents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAgents(options?: RawAxiosRequestConfig): AxiosPromise<IngestionStatus> {
            return localVarFp.indexAgents(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentControllerApi - object-oriented interface
 * @export
 * @class AgentControllerApi
 * @extends {BaseAPI}
 */
export class AgentControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get Agents
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {string} [agentName] 
     * @param {GetAgentsSearchDistanceUnitEnum} [searchDistanceUnit] 
     * @param {number} [distance] 
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentControllerApi
     */
    public getAgents(pageNumber?: number, pageSize?: number, agentName?: string, searchDistanceUnit?: GetAgentsSearchDistanceUnitEnum, distance?: number, latitude?: number, longitude?: number, options?: RawAxiosRequestConfig) {
        return AgentControllerApiFp(this.configuration).getAgents(pageNumber, pageSize, agentName, searchDistanceUnit, distance, latitude, longitude, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reindex Agent by id on Active index
     * @param {string} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentControllerApi
     */
    public indexAgentById(agentId: string, options?: RawAxiosRequestConfig) {
        return AgentControllerApiFp(this.configuration).indexAgentById(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Index Agents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentControllerApi
     */
    public indexAgents(options?: RawAxiosRequestConfig) {
        return AgentControllerApiFp(this.configuration).indexAgents(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAgentsSearchDistanceUnitEnum = {
    Kilometers: 'KILOMETERS',
    Miles: 'MILES'
} as const;
export type GetAgentsSearchDistanceUnitEnum = typeof GetAgentsSearchDistanceUnitEnum[keyof typeof GetAgentsSearchDistanceUnitEnum];


/**
 * KafkaRetryProducerControllerApi - axios parameter creator
 * @export
 */
export const KafkaRetryProducerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update provided failed messages status
         * @param {UpdateFailedMessageStatusBatch} updateFailedMessageStatusBatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchUpdateFailedMessageStatus: async (updateFailedMessageStatusBatch: UpdateFailedMessageStatusBatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateFailedMessageStatusBatch' is not null or undefined
            assertParamExists('batchUpdateFailedMessageStatus', 'updateFailedMessageStatusBatch', updateFailedMessageStatusBatch)
            const localVarPath = `/api/v1/kafka-retry/producer/status-batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFailedMessageStatusBatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List of failed messages
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {GetFailedMessagesSortDirectionEnum} [sortDirection] 
         * @param {Array<GetFailedMessagesSortByEnum>} [sortBy] 
         * @param {string} [topic] 
         * @param {string} [key] 
         * @param {GetFailedMessagesStatusEnum} [status] 
         * @param {number} [createdAtFrom] 
         * @param {number} [createdAtTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedMessages: async (pageNumber?: number, pageSize?: number, sortDirection?: GetFailedMessagesSortDirectionEnum, sortBy?: Array<GetFailedMessagesSortByEnum>, topic?: string, key?: string, status?: GetFailedMessagesStatusEnum, createdAtFrom?: number, createdAtTo?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/kafka-retry/producer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['createdAtFrom'] = createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['createdAtTo'] = createdAtTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retry one message by id
         * @param {FailedMessageRetryRequest} failedMessageRetryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryFailedMessage: async (failedMessageRetryRequest: FailedMessageRetryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'failedMessageRetryRequest' is not null or undefined
            assertParamExists('retryFailedMessage', 'failedMessageRetryRequest', failedMessageRetryRequest)
            const localVarPath = `/api/v1/kafka-retry/producer/retry-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(failedMessageRetryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retry messages by criteria
         * @param {FailedMessagesCriteriaRequest} failedMessagesCriteriaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryFailedMessages: async (failedMessagesCriteriaRequest: FailedMessagesCriteriaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'failedMessagesCriteriaRequest' is not null or undefined
            assertParamExists('retryFailedMessages', 'failedMessagesCriteriaRequest', failedMessagesCriteriaRequest)
            const localVarPath = `/api/v1/kafka-retry/producer/retry-messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(failedMessagesCriteriaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update failed event status
         * @param {FailedMessageUpdateStatusRequest} failedMessageUpdateStatusRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateFailedMessageStatus: async (failedMessageUpdateStatusRequest: FailedMessageUpdateStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'failedMessageUpdateStatusRequest' is not null or undefined
            assertParamExists('updateFailedMessageStatus', 'failedMessageUpdateStatusRequest', failedMessageUpdateStatusRequest)
            const localVarPath = `/api/v1/kafka-retry/producer/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(failedMessageUpdateStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KafkaRetryProducerControllerApi - functional programming interface
 * @export
 */
export const KafkaRetryProducerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KafkaRetryProducerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update provided failed messages status
         * @param {UpdateFailedMessageStatusBatch} updateFailedMessageStatusBatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchUpdateFailedMessageStatus(updateFailedMessageStatusBatch: UpdateFailedMessageStatusBatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchUpdateFailedMessageStatus(updateFailedMessageStatusBatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KafkaRetryProducerControllerApi.batchUpdateFailedMessageStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List of failed messages
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {GetFailedMessagesSortDirectionEnum} [sortDirection] 
         * @param {Array<GetFailedMessagesSortByEnum>} [sortBy] 
         * @param {string} [topic] 
         * @param {string} [key] 
         * @param {GetFailedMessagesStatusEnum} [status] 
         * @param {number} [createdAtFrom] 
         * @param {number} [createdAtTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFailedMessages(pageNumber?: number, pageSize?: number, sortDirection?: GetFailedMessagesSortDirectionEnum, sortBy?: Array<GetFailedMessagesSortByEnum>, topic?: string, key?: string, status?: GetFailedMessagesStatusEnum, createdAtFrom?: number, createdAtTo?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericSearchResponseFailedMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFailedMessages(pageNumber, pageSize, sortDirection, sortBy, topic, key, status, createdAtFrom, createdAtTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KafkaRetryProducerControllerApi.getFailedMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retry one message by id
         * @param {FailedMessageRetryRequest} failedMessageRetryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryFailedMessage(failedMessageRetryRequest: FailedMessageRetryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryFailedMessage(failedMessageRetryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KafkaRetryProducerControllerApi.retryFailedMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retry messages by criteria
         * @param {FailedMessagesCriteriaRequest} failedMessagesCriteriaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryFailedMessages(failedMessagesCriteriaRequest: FailedMessagesCriteriaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryFailedMessages(failedMessagesCriteriaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KafkaRetryProducerControllerApi.retryFailedMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update failed event status
         * @param {FailedMessageUpdateStatusRequest} failedMessageUpdateStatusRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateFailedMessageStatus(failedMessageUpdateStatusRequest: FailedMessageUpdateStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FailedMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFailedMessageStatus(failedMessageUpdateStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KafkaRetryProducerControllerApi.updateFailedMessageStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KafkaRetryProducerControllerApi - factory interface
 * @export
 */
export const KafkaRetryProducerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KafkaRetryProducerControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Update provided failed messages status
         * @param {UpdateFailedMessageStatusBatch} updateFailedMessageStatusBatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchUpdateFailedMessageStatus(updateFailedMessageStatusBatch: UpdateFailedMessageStatusBatch, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.batchUpdateFailedMessageStatus(updateFailedMessageStatusBatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List of failed messages
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {GetFailedMessagesSortDirectionEnum} [sortDirection] 
         * @param {Array<GetFailedMessagesSortByEnum>} [sortBy] 
         * @param {string} [topic] 
         * @param {string} [key] 
         * @param {GetFailedMessagesStatusEnum} [status] 
         * @param {number} [createdAtFrom] 
         * @param {number} [createdAtTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedMessages(pageNumber?: number, pageSize?: number, sortDirection?: GetFailedMessagesSortDirectionEnum, sortBy?: Array<GetFailedMessagesSortByEnum>, topic?: string, key?: string, status?: GetFailedMessagesStatusEnum, createdAtFrom?: number, createdAtTo?: number, options?: RawAxiosRequestConfig): AxiosPromise<GenericSearchResponseFailedMessage> {
            return localVarFp.getFailedMessages(pageNumber, pageSize, sortDirection, sortBy, topic, key, status, createdAtFrom, createdAtTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retry one message by id
         * @param {FailedMessageRetryRequest} failedMessageRetryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryFailedMessage(failedMessageRetryRequest: FailedMessageRetryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.retryFailedMessage(failedMessageRetryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retry messages by criteria
         * @param {FailedMessagesCriteriaRequest} failedMessagesCriteriaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryFailedMessages(failedMessagesCriteriaRequest: FailedMessagesCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.retryFailedMessages(failedMessagesCriteriaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update failed event status
         * @param {FailedMessageUpdateStatusRequest} failedMessageUpdateStatusRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateFailedMessageStatus(failedMessageUpdateStatusRequest: FailedMessageUpdateStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<FailedMessage> {
            return localVarFp.updateFailedMessageStatus(failedMessageUpdateStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KafkaRetryProducerControllerApi - object-oriented interface
 * @export
 * @class KafkaRetryProducerControllerApi
 * @extends {BaseAPI}
 */
export class KafkaRetryProducerControllerApi extends BaseAPI {
    /**
     * 
     * @summary Update provided failed messages status
     * @param {UpdateFailedMessageStatusBatch} updateFailedMessageStatusBatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KafkaRetryProducerControllerApi
     */
    public batchUpdateFailedMessageStatus(updateFailedMessageStatusBatch: UpdateFailedMessageStatusBatch, options?: RawAxiosRequestConfig) {
        return KafkaRetryProducerControllerApiFp(this.configuration).batchUpdateFailedMessageStatus(updateFailedMessageStatusBatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List of failed messages
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {GetFailedMessagesSortDirectionEnum} [sortDirection] 
     * @param {Array<GetFailedMessagesSortByEnum>} [sortBy] 
     * @param {string} [topic] 
     * @param {string} [key] 
     * @param {GetFailedMessagesStatusEnum} [status] 
     * @param {number} [createdAtFrom] 
     * @param {number} [createdAtTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KafkaRetryProducerControllerApi
     */
    public getFailedMessages(pageNumber?: number, pageSize?: number, sortDirection?: GetFailedMessagesSortDirectionEnum, sortBy?: Array<GetFailedMessagesSortByEnum>, topic?: string, key?: string, status?: GetFailedMessagesStatusEnum, createdAtFrom?: number, createdAtTo?: number, options?: RawAxiosRequestConfig) {
        return KafkaRetryProducerControllerApiFp(this.configuration).getFailedMessages(pageNumber, pageSize, sortDirection, sortBy, topic, key, status, createdAtFrom, createdAtTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retry one message by id
     * @param {FailedMessageRetryRequest} failedMessageRetryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KafkaRetryProducerControllerApi
     */
    public retryFailedMessage(failedMessageRetryRequest: FailedMessageRetryRequest, options?: RawAxiosRequestConfig) {
        return KafkaRetryProducerControllerApiFp(this.configuration).retryFailedMessage(failedMessageRetryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retry messages by criteria
     * @param {FailedMessagesCriteriaRequest} failedMessagesCriteriaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KafkaRetryProducerControllerApi
     */
    public retryFailedMessages(failedMessagesCriteriaRequest: FailedMessagesCriteriaRequest, options?: RawAxiosRequestConfig) {
        return KafkaRetryProducerControllerApiFp(this.configuration).retryFailedMessages(failedMessagesCriteriaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update failed event status
     * @param {FailedMessageUpdateStatusRequest} failedMessageUpdateStatusRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof KafkaRetryProducerControllerApi
     */
    public updateFailedMessageStatus(failedMessageUpdateStatusRequest: FailedMessageUpdateStatusRequest, options?: RawAxiosRequestConfig) {
        return KafkaRetryProducerControllerApiFp(this.configuration).updateFailedMessageStatus(failedMessageUpdateStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetFailedMessagesSortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetFailedMessagesSortDirectionEnum = typeof GetFailedMessagesSortDirectionEnum[keyof typeof GetFailedMessagesSortDirectionEnum];
/**
 * @export
 */
export const GetFailedMessagesSortByEnum = {
    CreatedAt: 'CREATED_AT',
    Status: 'STATUS'
} as const;
export type GetFailedMessagesSortByEnum = typeof GetFailedMessagesSortByEnum[keyof typeof GetFailedMessagesSortByEnum];
/**
 * @export
 */
export const GetFailedMessagesStatusEnum = {
    Blocked: 'BLOCKED',
    Unprocessed: 'UNPROCESSED',
    Processed: 'PROCESSED',
    Failed: 'FAILED',
    ManualOverride: 'MANUAL_OVERRIDE',
    NoActionRequired: 'NO_ACTION_REQUIRED'
} as const;
export type GetFailedMessagesStatusEnum = typeof GetFailedMessagesStatusEnum[keyof typeof GetFailedMessagesStatusEnum];


/**
 * PropertiesControllerApi - axios parameter creator
 * @export
 */
export const PropertiesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve property details by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyDetails1: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPropertyDetails1', 'id', id)
            const localVarPath = `/api/v1/properties/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PropertiesControllerApi - functional programming interface
 * @export
 */
export const PropertiesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PropertiesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieve property details by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPropertyDetails1(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealPropertyDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPropertyDetails1(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertiesControllerApi.getPropertyDetails1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PropertiesControllerApi - factory interface
 * @export
 */
export const PropertiesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PropertiesControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieve property details by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyDetails1(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RealPropertyDetails> {
            return localVarFp.getPropertyDetails1(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PropertiesControllerApi - object-oriented interface
 * @export
 * @class PropertiesControllerApi
 * @extends {BaseAPI}
 */
export class PropertiesControllerApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve property details by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesControllerApi
     */
    public getPropertyDetails1(id: string, options?: RawAxiosRequestConfig) {
        return PropertiesControllerApiFp(this.configuration).getPropertyDetails1(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PropertySearchControllerApi - axios parameter creator
 * @export
 */
export const PropertySearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve paginated property details for autosuggest
         * @param {string} query 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoSuggestPropertiesCollection: async (query: string, pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('getAutoSuggestPropertiesCollection', 'query', query)
            const localVarPath = `/api/v1/search/properties/autosuggest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve property details by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getPropertyDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPropertyDetails', 'id', id)
            const localVarPath = `/api/v1/search/property/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve paginated property details
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyDetailsCollection: async (pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/search/properties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve paginated property details within a radius
         * @param {SearchPropertiesLocationRequest} searchPropertiesLocationRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchPropertiesByLocationCollection: async (searchPropertiesLocationRequest: SearchPropertiesLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchPropertiesLocationRequest' is not null or undefined
            assertParamExists('searchPropertiesByLocationCollection', 'searchPropertiesLocationRequest', searchPropertiesLocationRequest)
            const localVarPath = `/api/v1/search/property/radial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchPropertiesLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve paginated property details within a polygon
         * @param {SearchPropertiesPolygonRequest} searchPropertiesPolygonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPropertiesByPolygonCollection: async (searchPropertiesPolygonRequest: SearchPropertiesPolygonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchPropertiesPolygonRequest' is not null or undefined
            assertParamExists('searchPropertiesByPolygonCollection', 'searchPropertiesPolygonRequest', searchPropertiesPolygonRequest)
            const localVarPath = `/api/v1/search/properties/polygon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchPropertiesPolygonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve paginated property details within a radius
         * @param {SearchPropertiesLocationRequest} searchPropertiesLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPropertiesRadial: async (searchPropertiesLocationRequest: SearchPropertiesLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchPropertiesLocationRequest' is not null or undefined
            assertParamExists('searchPropertiesRadial', 'searchPropertiesLocationRequest', searchPropertiesLocationRequest)
            const localVarPath = `/api/v1/search/properties/radial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchPropertiesLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PropertySearchControllerApi - functional programming interface
 * @export
 */
export const PropertySearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PropertySearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieve paginated property details for autosuggest
         * @param {string} query 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutoSuggestPropertiesCollection(query: string, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealPropertiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutoSuggestPropertiesCollection(query, pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertySearchControllerApi.getAutoSuggestPropertiesCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve property details by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getPropertyDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealPropertiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPropertyDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertySearchControllerApi.getPropertyDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve paginated property details
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPropertyDetailsCollection(pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealPropertiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPropertyDetailsCollection(pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertySearchControllerApi.getPropertyDetailsCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve paginated property details within a radius
         * @param {SearchPropertiesLocationRequest} searchPropertiesLocationRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async searchPropertiesByLocationCollection(searchPropertiesLocationRequest: SearchPropertiesLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealPropertiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPropertiesByLocationCollection(searchPropertiesLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertySearchControllerApi.searchPropertiesByLocationCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve paginated property details within a polygon
         * @param {SearchPropertiesPolygonRequest} searchPropertiesPolygonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPropertiesByPolygonCollection(searchPropertiesPolygonRequest: SearchPropertiesPolygonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealPropertiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPropertiesByPolygonCollection(searchPropertiesPolygonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertySearchControllerApi.searchPropertiesByPolygonCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve paginated property details within a radius
         * @param {SearchPropertiesLocationRequest} searchPropertiesLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPropertiesRadial(searchPropertiesLocationRequest: SearchPropertiesLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealPropertiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPropertiesRadial(searchPropertiesLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertySearchControllerApi.searchPropertiesRadial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PropertySearchControllerApi - factory interface
 * @export
 */
export const PropertySearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PropertySearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieve paginated property details for autosuggest
         * @param {string} query 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoSuggestPropertiesCollection(query: string, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<RealPropertiesResponse> {
            return localVarFp.getAutoSuggestPropertiesCollection(query, pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve property details by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getPropertyDetails(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RealPropertiesResponse> {
            return localVarFp.getPropertyDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve paginated property details
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyDetailsCollection(pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<RealPropertiesResponse> {
            return localVarFp.getPropertyDetailsCollection(pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve paginated property details within a radius
         * @param {SearchPropertiesLocationRequest} searchPropertiesLocationRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchPropertiesByLocationCollection(searchPropertiesLocationRequest: SearchPropertiesLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<RealPropertiesResponse> {
            return localVarFp.searchPropertiesByLocationCollection(searchPropertiesLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve paginated property details within a polygon
         * @param {SearchPropertiesPolygonRequest} searchPropertiesPolygonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPropertiesByPolygonCollection(searchPropertiesPolygonRequest: SearchPropertiesPolygonRequest, options?: RawAxiosRequestConfig): AxiosPromise<RealPropertiesResponse> {
            return localVarFp.searchPropertiesByPolygonCollection(searchPropertiesPolygonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve paginated property details within a radius
         * @param {SearchPropertiesLocationRequest} searchPropertiesLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPropertiesRadial(searchPropertiesLocationRequest: SearchPropertiesLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<RealPropertiesResponse> {
            return localVarFp.searchPropertiesRadial(searchPropertiesLocationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PropertySearchControllerApi - object-oriented interface
 * @export
 * @class PropertySearchControllerApi
 * @extends {BaseAPI}
 */
export class PropertySearchControllerApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve paginated property details for autosuggest
     * @param {string} query 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySearchControllerApi
     */
    public getAutoSuggestPropertiesCollection(query: string, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return PropertySearchControllerApiFp(this.configuration).getAutoSuggestPropertiesCollection(query, pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve property details by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PropertySearchControllerApi
     */
    public getPropertyDetails(id: string, options?: RawAxiosRequestConfig) {
        return PropertySearchControllerApiFp(this.configuration).getPropertyDetails(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve paginated property details
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySearchControllerApi
     */
    public getPropertyDetailsCollection(pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return PropertySearchControllerApiFp(this.configuration).getPropertyDetailsCollection(pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve paginated property details within a radius
     * @param {SearchPropertiesLocationRequest} searchPropertiesLocationRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PropertySearchControllerApi
     */
    public searchPropertiesByLocationCollection(searchPropertiesLocationRequest: SearchPropertiesLocationRequest, options?: RawAxiosRequestConfig) {
        return PropertySearchControllerApiFp(this.configuration).searchPropertiesByLocationCollection(searchPropertiesLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve paginated property details within a polygon
     * @param {SearchPropertiesPolygonRequest} searchPropertiesPolygonRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySearchControllerApi
     */
    public searchPropertiesByPolygonCollection(searchPropertiesPolygonRequest: SearchPropertiesPolygonRequest, options?: RawAxiosRequestConfig) {
        return PropertySearchControllerApiFp(this.configuration).searchPropertiesByPolygonCollection(searchPropertiesPolygonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve paginated property details within a radius
     * @param {SearchPropertiesLocationRequest} searchPropertiesLocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySearchControllerApi
     */
    public searchPropertiesRadial(searchPropertiesLocationRequest: SearchPropertiesLocationRequest, options?: RawAxiosRequestConfig) {
        return PropertySearchControllerApiFp(this.configuration).searchPropertiesRadial(searchPropertiesLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReferralControllerApi - axios parameter creator
 * @export
 */
export const ReferralControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Referrals
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [agentName] 
         * @param {GetReferralsSearchDistanceUnitEnum} [searchDistanceUnit] 
         * @param {number} [distance] 
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrals: async (pageNumber?: number, pageSize?: number, agentName?: string, searchDistanceUnit?: GetReferralsSearchDistanceUnitEnum, distance?: number, latitude?: number, longitude?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/referrals/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (agentName !== undefined) {
                localVarQueryParameter['agentName'] = agentName;
            }

            if (searchDistanceUnit !== undefined) {
                localVarQueryParameter['searchDistanceUnit'] = searchDistanceUnit;
            }

            if (distance !== undefined) {
                localVarQueryParameter['distance'] = distance;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reindex Referral by id on Active index
         * @param {string} referralId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexReferralById: async (referralId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referralId' is not null or undefined
            assertParamExists('indexReferralById', 'referralId', referralId)
            const localVarPath = `/api/v1/referrals/reindex/{referralId}`
                .replace(`{${"referralId"}}`, encodeURIComponent(String(referralId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Index Referrals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexReferrals: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/referrals/reindex`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReferralControllerApi - functional programming interface
 * @export
 */
export const ReferralControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReferralControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Referrals
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [agentName] 
         * @param {GetReferralsSearchDistanceUnitEnum} [searchDistanceUnit] 
         * @param {number} [distance] 
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferrals(pageNumber?: number, pageSize?: number, agentName?: string, searchDistanceUnit?: GetReferralsSearchDistanceUnitEnum, distance?: number, latitude?: number, longitude?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericSearchResponseReferralDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferrals(pageNumber, pageSize, agentName, searchDistanceUnit, distance, latitude, longitude, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.getReferrals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reindex Referral by id on Active index
         * @param {string} referralId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexReferralById(referralId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexReferralById(referralId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.indexReferralById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Index Referrals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexReferrals(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexReferrals(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.indexReferrals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReferralControllerApi - factory interface
 * @export
 */
export const ReferralControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReferralControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Referrals
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [agentName] 
         * @param {GetReferralsSearchDistanceUnitEnum} [searchDistanceUnit] 
         * @param {number} [distance] 
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrals(pageNumber?: number, pageSize?: number, agentName?: string, searchDistanceUnit?: GetReferralsSearchDistanceUnitEnum, distance?: number, latitude?: number, longitude?: number, options?: RawAxiosRequestConfig): AxiosPromise<GenericSearchResponseReferralDto> {
            return localVarFp.getReferrals(pageNumber, pageSize, agentName, searchDistanceUnit, distance, latitude, longitude, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reindex Referral by id on Active index
         * @param {string} referralId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexReferralById(referralId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.indexReferralById(referralId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Index Referrals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexReferrals(options?: RawAxiosRequestConfig): AxiosPromise<IngestionStatus> {
            return localVarFp.indexReferrals(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReferralControllerApi - object-oriented interface
 * @export
 * @class ReferralControllerApi
 * @extends {BaseAPI}
 */
export class ReferralControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get Referrals
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {string} [agentName] 
     * @param {GetReferralsSearchDistanceUnitEnum} [searchDistanceUnit] 
     * @param {number} [distance] 
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public getReferrals(pageNumber?: number, pageSize?: number, agentName?: string, searchDistanceUnit?: GetReferralsSearchDistanceUnitEnum, distance?: number, latitude?: number, longitude?: number, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).getReferrals(pageNumber, pageSize, agentName, searchDistanceUnit, distance, latitude, longitude, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reindex Referral by id on Active index
     * @param {string} referralId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public indexReferralById(referralId: string, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).indexReferralById(referralId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Index Referrals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public indexReferrals(options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).indexReferrals(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetReferralsSearchDistanceUnitEnum = {
    Kilometers: 'KILOMETERS',
    Miles: 'MILES'
} as const;
export type GetReferralsSearchDistanceUnitEnum = typeof GetReferralsSearchDistanceUnitEnum[keyof typeof GetReferralsSearchDistanceUnitEnum];


